import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
});

export function HomeIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M21.797,5.579L14.797,.855c-1.699-1.146-3.895-1.146-5.594,0L2.204,5.579c-1.38,.93-2.204,2.479-2.204,4.145v9.276c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V9.724c0-1.665-.824-3.215-2.203-4.145Zm-5.797,10.421c0,1.103-.897,2-2,2h-4c-1.103,0-2-.897-2-2v-4c0-1.103,.897-2,2-2h4c1.103,0,2,.897,2,2v4Zm-2-4l.002,4h-4.002v-4h4Z" />
    </svg>
  );
}

export function EatIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...props} width={size} height={size} viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="m24 2a22 22 0 0 0 -11.07 41.009l.84-11.749a6.5 6.5 0 0 1 -4.77-6.26c0-3.59 1.5-11 6.5-11s6.5 7.41 6.5 11a6.5 6.5 0 0 1 -4.77 6.26l1 13.97a22 22 0 0 0 11.54 0l1.09-15.37a4.988 4.988 0 0 1 -3.86-4.86v-10a1 1 0 0 1 2 0v5.75a1.25 1.25 0 0 0 2.5 0v-5.75a1 1 0 0 1 2 0v5.75a1.25 1.25 0 0 0 2.5 0v-5.75a1 1 0 0 1 2 0v10a4.988 4.988 0 0 1 -3.86 4.86l.93 13.149a22 22 0 0 0 -11.07-41.009z" />
    </svg>
  );
}

export function FlameIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M12,24c-5.514,0-10-4.486-10-10h0c0-3.358,1.505-5.459,3.765-7.58l2.448-2.299-.792,3.263c-.275,1.136-.347,4.606,1.112,6.461,.611,.777,1.418,1.155,2.467,1.155,1.107,0,1.986-.884,2-2.013,.014-1.117-.458-2.042-.958-3.02-.512-1.002-1.042-2.037-1.042-3.295,0-2.711,1.412-5.168,1.472-5.271L13.3-.021l.881,1.391c.849,1.339,1.994,2.587,3.103,3.794,2.319,2.524,4.717,5.136,4.717,8.837,0,5.514-4.486,10-10,10Z" />
    </svg>
  );
}

export function MarkerIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M12,.042a9.992,9.992,0,0,0-9.981,9.98c0,2.57,1.99,6.592,5.915,11.954a5.034,5.034,0,0,0,8.132,0c3.925-5.362,5.915-9.384,5.915-11.954A9.992,9.992,0,0,0,12,.042ZM12,14a4,4,0,1,1,4-4A4,4,0,0,1,12,14Z" />
    </svg>
  );
}

export function BasketIcon({ size = 18, ...props }: IconProps) {
  return (
    <svg {...base(size)} {...props}>
      <path d="M23.297,9.035c-.57-.658-1.396-1.035-2.267-1.035h-.089C20.441,3.507,16.624,0,12,0S3.559,3.507,3.059,8h-.059c-.871,0-1.697,.377-2.267,1.035C.164,9.692-.093,10.563,.031,11.424l1.061,7.424c.419,2.937,2.973,5.151,5.939,5.151h9.969c2.966,0,5.52-2.215,5.939-5.151l1.061-7.424c.124-.861-.133-1.732-.703-2.39Zm-8.297,7.965h-6c-.552,0-1-.448-1-1s.448-1,1-1h6c.552,0,1,.448,1,1s-.448,1-1,1ZM5.08,8c.488-3.387,3.401-6,6.92-6s6.432,2.613,6.92,6H5.08Z" />
    </svg>
  );
}
